import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

export default new Router({
  /* mode: process.env.CORDOVA_PLATFORM ? 'hash' : 'history', */
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "inicio",
      component: () => import("./views/Main.vue"),
      beforeEnter(to, from, next) {
        if (store.getters.loggedIn) {
          next();
        } else {
          next();
        }
      },
      children: [
        {
          path: "/principal",
          name: "principal",
          component: () => import("./views/Principal/index.vue"),
          // meta: { requiresAuth: false },
        },
        {
          path: "/product",
          name: "product",
          component: () => import("./views/Principal/product.vue"),
          // meta: { requiresAuth: false },
        },
      ],
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/Login/Login.vue"),
    },
    {
      path: "/register",
      name: "register",
      component: () => import("./views/Login/Register.vue"),
    },
    {
      path: "/config",
      name: "config",
      component: () => import("./views/Confing/Main.vue"),
    },
  ],
});
